<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-breadcrumbs
      :items="breadcrumbs"
      divider=">"
    ></v-breadcrumbs>
    <v-data-table
    :headers="headers"
    :items="items"
    sort-by="calories"
    class="elevation-1"
    >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>资源列表</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="资源名称"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-autocomplete
                      v-model="editedItem.children"
                      :items="items"
                      item-text="name"
                      item-value="identity"
                      label="子资源名称"
                      multiple
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                取消
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
     
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        重新载入
      </v-btn>
    </template>
  </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { resourceTypeService} from '@/api/resource-type.service';
export default {
    name:'resourceManagement',
    data: () => ({
      dialog: false,
      headers: [
        {
          text: '名称',
          align: 'start',
          value: 'name',
        },
        {
          text: '父资源个数',
          value: 'numOfParent',
        },
        {
          text: '子资源个数',
          value: 'numOfChildren',
        },
        { text: '操作', value: 'actions',  align: 'end', sortable: false },
      ],
      breadcrumbs:[ {
          text: '资源类型',
          disabled: false,
          href: '#/resourceType',
        },
        {
          text: '资源列表',
          disabled: false,
          href: '',
        },],
      items: [],
      editedIndex: -1,
      editedItem: {
        identity:'',
        name: '',
        parent: 0,
        numOfParent: 0,
        numOfChildren:0,
        children: []
      },
      defaultItem: {
        identity: '',
        name: '',
        parent: 0,
        numOfParent: 0,
        numOfChildren:0,
        children: []
      },
      typeId: '',
      isLoading: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : '编辑资源关系'
      },
     ...mapGetters(["resourceByType"])

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        this.items = [];
        this.isLoading = true;
        await this.$store.dispatch('getResourceByType', this.$route.params.id)
        this.isLoading = false;
        this.items = this.resourceByType(this.$route.params.id).map(o=>{return {
            identity: o.Identity,
            name: o.Name,
            numOfChildren: o.numOfChildren,
            numOfParent: o.numOfParent
        }});
      },

      async editItem (item) {
        this.isLoading = true;
        let result = await resourceTypeService.getRelationByResource(item.identity);
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.children = result.ChildResourceIdentity;
        this.isLoading = false;
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.items.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        if (this.editedIndex > -1) {
         if (!this.editedItem.children) this.editedItem.children = [];
          Object.assign(this.items[this.editedIndex], this.editedItem)
          let payload = {
              ParentResourceIdentity: this.editedItem.identity,
              ChildResourceIdentity: this.editedItem.children
          }
          this.isLoading = true;
          await resourceTypeService.putRelationByResource(payload);
          this.isLoading = false;
        } else {
          this.desserts.push(this.editedItem)
           let payload = {
              ParentResourceIdentity: this.editedItem.identity,
              ChildResourceIdentity: this.editedItem.children
          }
          this.isLoading = true;
          await resourceTypeService.postRelationByResource(payload);
          this.isLoading = false;
        }
        this.initialize();
        this.close()
      },
    },
  
    mounted(){
        if (!this.$route.params.id) this.$router.push('/');
        this.typeId = this.$route.params.id;
        this.initialize();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/management/resourceManagement.vue